import React from "react";

import { faCalendarDays } from "@performyard/fontawesome/pro-regular-svg-icons";
import { Icon } from "@performyard/py-components";
import type { MeetingModelJson } from "@performyard/service-contracts";

import { GoogleCalendarIcon } from "../../../UserSettings/Views/MeetingsIntegrations/components/GoogleCalendarIcon";
import { OutlookCalendarIcon } from "../../../UserSettings/Views/MeetingsIntegrations/components/OutlookCalendarIcon";

type MeetingCalendarIconProps = {
	meeting: MeetingModelJson;
};

const MeetingCalendarIcon = ({ meeting }: MeetingCalendarIconProps): React.ReactElement => {
	// Show generic calendar icon if meeting is not connected to calendar
	if (!meeting.calendarEvent?.eventId) {
		return (
			<div className="flex h-6 w-6 items-center justify-center">
				<Icon size={24} icon={faCalendarDays} color="primary-5" />
			</div>
		);
	}

	// Show provider-specific icon based on the provider that was used to create the calendar event
	const calendarProvider = meeting.calendarEvent?.provider;

	if (calendarProvider === "google") {
		return (
			<div className="flex w-6 items-center justify-center">
				<div className="flex h-5 w-5 items-center justify-center">
					<GoogleCalendarIcon />
				</div>
			</div>
		);
	}

	if (calendarProvider === "outlook") {
		return (
			<div className="flex w-6 items-center justify-center">
				<div className="flex h-5 w-5 items-center justify-center">
					<OutlookCalendarIcon />
				</div>
			</div>
		);
	}

	// Fallback to generic calendar icon if provider is not recognized
	return (
		<div className="flex h-6 w-6 items-center justify-center">
			<Icon size={24} icon={faCalendarDays} color="primary-5" />
		</div>
	);
};

export default MeetingCalendarIcon;
